import type { RibbonControlGroupDefinitionSLR, RibbonTabDefinitionBase } from 'owa-acui';
import { owaComputedFn } from 'owa-computed-fn';
import { constructKeytip, SingleLine } from 'owa-command-ribbon';
import loc from 'owa-localize';
import { getMailRibbonConfigStore } from 'owa-mail-ribbon-store/lib/store/store';
import { send_receive_tab as Strings_send_receive_tab } from 'owa-mail-ribbon-utils/lib/ribbon_mail_strings.locstring.json';
import type { ReadOnlyRibbonControlDefProps } from 'owa-mail-ribbon-utils';
import { getUniqueTabId } from 'owa-mail-ribbon-utils/lib/getUniqueTabId';
import { type MailRibbonTabId } from 'owa-ribbon-ids/lib/mailRibbonId';
import { getTabGroups } from '../../../util/getTabGroups';
import { getSLRSendReceiveTabControlDefinition } from './getSLRSendReceiveTabControlDefinition';

const getSLRSendReceiveTab: (
    props: ReadOnlyRibbonControlDefProps
) => RibbonTabDefinitionBase | undefined = owaComputedFn(function getSLRSendReceiveTab(
    props: ReadOnlyRibbonControlDefProps
): RibbonTabDefinitionBase | undefined {
    // we check for the length of the groups to avoid rendering an empty tab when all controls are hidden,
    // because there are conditions where the sync button (currently the only button in the tab) is not shown
    const groups = getSendReceiveTabGroups(props);
    if (!groups.some(group => group.controls.length > 0)) {
        return undefined;
    }

    return {
        type: SingleLine,
        id: getUniqueTabId(16, undefined /* editorId */, props.itemId, props.isPopout),
        title: loc(Strings_send_receive_tab),
        controlGroups: { type: SingleLine, groups },
        initialScalingSteps: [],
        scalingSteps: [],
        keytipProps: constructKeytip([], 16, true /* hasMenu */),
    };
});

const getSendReceiveTabGroups: (
    props: ReadOnlyRibbonControlDefProps
) => RibbonControlGroupDefinitionSLR[] = owaComputedFn(function getSendReceiveTabGroups(
    props: ReadOnlyRibbonControlDefProps
): RibbonControlGroupDefinitionSLR[] {
    let sendReceiveTabGroups: RibbonControlGroupDefinitionSLR[] = new Array();
    sendReceiveTabGroups = getTabGroups(
        16,
        getMailRibbonConfigStore(props.mailboxInfo).singleline.sendReceiveTab.layout,
        getSLRSendReceiveTabControlDefinition,
        props
    );

    return sendReceiveTabGroups;
});

export default getSLRSendReceiveTab;
